import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleCheckout = () => {
    window.location.href = 'https://everithingforyou.com/cart/47902757847265:1';
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-20 px-4" data-id="element-15">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-cream-100 to-cream-200 z-0" data-id="element-16" />
      <div className="absolute inset-0 opacity-30 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] z-0 mix-blend-multiply" data-id="element-17" />

      <div className="container mx-auto max-w-6xl relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-18">
        {/* Text Content */}
        <div className="text-center md:text-left order-2 md:order-1" data-id="element-19">
          <FadeIn delay={100} data-id="element-20">
            <span className="inline-block py-1 px-3 rounded-full bg-burgundy-100 text-burgundy-800 text-sm font-medium tracking-wide mb-6" data-id="element-21">
              PARA PAREJAS QUE SE QUIEREN
            </span>
          </FadeIn>

          <FadeIn delay={200} data-id="element-22">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-burgundy-900 leading-tight mb-6" data-id="element-23">
              7 noches para volver a tocarse…{' '}
              <span className="italic font-light text-burgundy-700" data-id="element-24">
                sin pasar vergüenza
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={300} data-id="element-25">
            <p className="text-lg md:text-xl text-burgundy-900/80 mb-8 max-w-lg mx-auto md:mx-0 leading-relaxed" data-id="element-26">
              Para novios que se quieren… pero se traban. Recupera la intimidad
              sin presión, sin "tener que hablarlo" y sin miedo al rechazo.
            </p>
          </FadeIn>

          <FadeIn delay={400} data-id="element-27">
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-28">
              <Button onClick={handleCheckout} className="min-w-[200px]" data-id="element-29">
                Empezar esta noche - $6.39
              </Button>
            </div>
            <p className="mt-4 text-sm text-burgundy-900/60 italic" data-id="element-30">
              Descarga inmediata • Privado y seguro
            </p>
          </FadeIn>
        </div>

        {/* Image Content with Parallax */}
        <div className="relative order-1 md:order-2 flex justify-center" data-id="element-31">
          <FadeIn delay={200} className="relative w-full max-w-md" data-id="element-32">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-burgundy-900/20" style={{
            transform: `translateY(${offset * 0.05}px)`
          }} data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/kMEcWmMwAmV93CN4SnPkah/PORTADA_7_NOCHES.png" alt="7 Noches Para Volver a Tocarnos Book Cover" className="w-full h-auto object-cover" data-id="element-34" />
              {/* Shine effect overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-burgundy-900/10 to-transparent pointer-events-none" data-id="element-35" />
            </div>

            {/* Decorative elements behind */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-gold-200/30 rounded-full blur-3xl -z-10" data-id="element-36" />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-burgundy-200/30 rounded-full blur-3xl -z-10" data-id="element-37" />
          </FadeIn>
        </div>
      </div>
    </section>;
}